//Función para formatear las fechas al formato "Feb 16, 2024 10:51 PM".
export const formatDateAlt = (inputDate) => {
    const date = new Date(inputDate);
    const options = {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        timeZone: 'UTC'
    };
    const formattedDate = date.toLocaleString('en-US', options);
    return formattedDate;
};

